import request from "../utils/request";

export function getCompanyInfo(slug) {
  return request({
    url: slug ? `/portal/${slug}/info` : `/portal/info`,
    method: "get",
  });
}

export function sendComplaint(slug, complaint) {
  return request({
    url: `/complaints/${slug}`,
    method: "post",
    data: {
      complaint,
    },
  });
}

export function getBusinessGroups(slug) {
  return request({
    url: `/companies/${slug}/business-groups`,
    method: "get",
  });
}

export function getLevels(slug) {
  return request({
    url: `/companies/${slug}/levels`,
    method: "get",
  });
}

export function sendQaS(slug, qas) {
  return request({
    url: `/qas/${slug}`,
    method: "post",
    data: {
      qas,
    },
  });
}

export function sendDSAR(slug, dsar) {
  return request({
    url: `/dsar/${slug}`,
    method: "post",
    data: {
      dsar,
    },
  });
}

export function sendOmbudsmanRecord(slug, record) {
  return request({
    url: `/ombudsman/${slug}`,
    method: "post",
    data: {
      record,
    },
  });
}

export function consultProtocol(slug, protocol) {
  return request({
    url: `/protocol/${slug}/${protocol}`,
    method: "get",
  });
}

export function sendProtocolResponse(slug, protocol, response) {
  return request({
    url: `/protocol/${slug}/${protocol}/response`,
    method: "post",
    data: {
      response,
    },
  });
}

export function getTaskInfo(token) {
  return request({
    url: `/events/${token}/`,
    method: "get",
  });
}

export function sendTaskResponse(token, response) {
  return request({
    url: `/events/${token}/`,
    method: "post",
    data: {
      response,
    },
  });
}

export function getOmbudsmanTaskInfo(token) {
  return request({
    url: `/ombudsman-events/${token}/`,
    method: "get",
  });
}

export function sendOmbudsmanTaskResponse(token, response) {
  return request({
    url: `/ombudsman-events/${token}/`,
    method: "post",
    data: {
      response,
    },
  });
}

export function getClassificationValues(slug, type, group) {
  return request({
    url: `/companies/${slug}/classifications/type/${type}?group=${group}`,
    method: "get",
  });
}

export function getPortalClassifications(slug) {
  return request({
    url: `/companies/${slug}/classifications`,
    method: "get",
  });
}
